









































import { debounce } from '~/utils/function'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import { computed, defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import { ciMagnifyingGlass } from '~/icons/source/regular/magnifying-glass'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: { CCustomSelect },
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()
    const { state: classifiedSearchState } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )

    const query = ref(props.selected.query || '')
    const selectedValues = ref(props.selected.values || [])
    const size = ref(props.selected.size)

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const options = computed(() =>
      (props.searchables || []).map(s => ({
        value: s.v,
        label: s.n,
        count: s.c
      }))
    )

    watch(
      () => props.selected,
      (newSelected: { query: string; values: number[]; size: number }) => {
        query.value = newSelected.query || ''
        selectedValues.value = newSelected.values || []
        size.value = newSelected.size
      }
    )

    function onClearButtonClick() {
      query.value = ''
      selectedValues.value = []
      size.value = null

      emitValues()
    }

    function onSelectedValuesChange() {
      emitValues()
    }

    function emitValues() {
      changeParams([
        { name: `${props.name}-q`, value: query.value },
        { name: `${props.name}-s`, value: size.value },
        { name: props.name, value: selectedValues.value }
      ])
    }

    const onSearchQueryChange = debounce(() => {
      emitValues()
    }, DEBOUNCE_DEFAULT)

    return {
      ciMagnifyingGlass,
      query,
      selectedValues,
      size,
      options,
      loadingFacets,
      onSearchQueryChange,
      onSelectedValuesChange,
      onClearButtonClick
    }
  }
})
